<template>
<div>
  <div style="height: calc(100%)">
 
  <user-client-typeahead @onHit="onHitTypeahead" @onSearch="onClickCancel" @onClickNew="onClickNew"></user-client-typeahead>
            
  <div v-show="!(userClient.id > 0)" style="padding-top: 20px">
    <div class="pull-right">
      <button 
        type="button" class="btn btn-link" 
        v-on:click="onClickNew">
        Mitarbeiter - Abteilung - Thema anlegen
      </button>
    </div>
  </div>

    <div v-show="!userClient.id">
        <button 
          type="button" class="btn btn-default" :disabled="userClientHistory.length < 2" 
          v-on:click="onClickHistoryBack" :title="historyTitle">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </button>  
    </div>      
   <div v-show="userClient.id > 0" class="user-client" style="height: calc(100% - 55px)">
    
    <div style="border-bottom: 1px solid #CCC;">
      <h2>
        <button 
          type="button" class="btn btn-default" :disabled="userClientHistory.length < 2"
          v-on:click="onClickHistoryBack" :title="historyTitle">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </button>        
        <i style="color: purple;" class="fa" v-bind:class="typeIconClass" aria-hidden="true"></i>
        <span v-text="sexText"></span>
         {{userClient.firstName}} {{userClient.lastName}} - 
        <small>{{userClient.department}}, {{userClient.function}}, {{userClient.room}} </small>
        <button 
          type="button"
          class="btn btn-default"
          title="Kopiere Link in Zwischenablage"
          v-clipboard:copy="'{intern::' + userClient.id + '::' + userClient.firstName + ' ' + userClient.lastName + ' ' + userClient.department + ' ' + userClient.function + '}'"
          >
          <i class="fa fa-link"></i>
        </button>        
  

        <div class="pull-right">
          <button 
            type="button" class="btn btn-default" 
            v-on:click="onClickEdit">
            <i class="fa fa-pencil" title="bearbeiten"></i>
          </button>
          
          <button 
            type="button" class="btn btn-default" 
            v-on:click="onClickCancel">
            <i class="fa fa-eye-slash" title="ausblenden"></i>
          </button>        

          <button v-show="userClient.calltemplate" 
            type="button" class="btn btn-default" 
            v-on:click="onClickAddTemplate"
            title="Vorlage in Nachricht einfügen">
            <i class="fa fa-file-text" aria-hidden="true"></i>
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div> 
      </h2>
    </div> 

    <div class="row" style="height: calc(100% - 55px)">

      <div class="col-xs-8" style="border-right: 1px solid #CCC; height:100%" >
        <div class="cc-memo-list">
          <div class="panel-group" id="user-client-memo-accordion" role="tablist" aria-multiselectable="true">
            <cc-memo
              class="panel cc-panel-default cc-memo-item" 
              v-for="(memo, index) in memos"
              :collapseIn="isMemoCollapse(index)"
              :data_parent="'xuser-client-memo-accordion'"
              :memo="memo"
              :key="memo.id" 
              @remove="onRemoveMemo"
              @update="onSetMemo">
            </cc-memo>
          </div>
    
          <div v-show="!memos.length" class="alert alert-warning" role="alert">Keine Vorgaben</div>
            <cc-memo 
              v-if="userClient.id > 0 && idCompanyClient > 0"
              class="cc-kombox-item"
              :idCompany= 0
              :idUser="userClient.id"
              @insert="onAddMemo">
            </cc-memo>
          </div>      
        </div>

        <div class="col-xs-4" style="height:100%">
          <div class="cc-kombox-list">
            <cc-kombox 
              class="cc-kombox-item" 
              v-for="kombox in komboxes"
              :kombox="kombox"
              :key="kombox.id" 
              @add-shipping="onKomboxAddShipping"
              @remove-shipping="onKomboxRemoveShipping"
              @remove="onRemoveKombox"
              @update="onSetKombox">
            </cc-kombox>

            <div v-show="!komboxes.length" class="alert alert-warning text-center" role="alert">
              Keine Komboxen
            </div>

            <cc-kombox 
              v-if="userClient.id > 0 && idCompanyClient > 0"
              class="cc-kombox-item" 
              :idCompany="idCompanyClient"
              :idUser="userClient.id"
              @insert="onAddKombox">
            </cc-kombox>

          </div>
        </div>
      </div>
    </div>            
  </div>                   

    <cc-user-client-modal 
      v-if="editModus == 'edit'" 
      :userClient="userClient"  
      @cancel="editModus = false"
      @save="saveUserClient">
    </cc-user-client-modal>

    <cc-user-client-modal 
      v-if="editModus == 'new'" 
      :idCompanyClient="idCompanyClient"
      @cancel="editModus = false"
      @save="saveUserClient">
    </cc-user-client-modal>
    
</div>    
</template>



<script>

import Kombox from './Kombox.vue'
import Memo from './Memo.vue'
import bus from './common/bus'
import UserClientTypeahead from './UserClientTypeahead.vue'
import UserClientModal from './UserClientModal.vue'


export default {
    
  components: {
    'cc-user-client-modal': UserClientModal,
    'user-client-typeahead': UserClientTypeahead,
    'cc-kombox': Kombox,
    'cc-memo': Memo,
  },
  
  data () {
    return {
      editModus: false,
      idCompanyClient: 0,
      userClient: {},
      userClientHistory: [],
      memos:[],
      komboxes:[],
      shippingIds: bus.shipping.idsUserClient,
      userClientType: {
         '': {class: 'fa-question', text: 'Unbekannt', sexText: ''},
         0: {class: 'fa-question', text: 'Unbekannt', sexText: ''},
         1: {class: 'fa-user', text: 'Herr', sexText: 'Herr'},
         2: {class: 'fa-user', text: 'Frau', sexText: 'Frau'},
         3: {class: 'fa-users', text: 'Abteilung', sexText: ''},
         4: {class: 'fa-commenting', text: 'Thema', sexText: ''}
      }

    }
  },
  
  created: function () {
    bus.registerOnLogout(this.reset);
    bus.registerOnIdUserClient(this.onIdUserClient);
  },
  
  computed: {
    
    sexText: function () {
      if(typeof this.userClient.idSex == 'string'){
        return this.userClientType[this.userClient.idSex].sexText;
      }
    },

    typeIconClass: function () {
      if(typeof this.userClient.idSex == 'string'){
        return this.userClientType[this.userClient.idSex].class
      }
    },
      
    userClientHeadline: function () {
      /* TODO */
      return "";
    },
    
    historyTitle: function () {
      if(this.userClientHistory.length >= 2){
        let history = this.userClientHistory[this.userClientHistory.length - 2]
        return history.firstName + " " + history.lastName + " - " + history.department + ", " + history.function + ", " + history.room
      }else{
        return ""
      }
    },
    
    
  },
  
  methods: {

    isMemoCollapse: function (index) {
      // Todo: outsourcing Logic to 'MEMO' see also CompanyClient 
      
      if(this.memos[index].view == 'v'){
        return true // view
      }else if(this.memos[index].view == 'h'){
        return false // hide
      }else if(this.memos[index].typ == '0'){
        return true // 0 == Vorgabe immer öffnen
      }else{
        return (index == 0) // automatic open first
      }
    },



    onClickHistoryBack: function () {
      this.userClientHistory.pop() // remove actually
      let history = this.userClientHistory.pop() // remove actually
      if(typeof history !== "undefined"){
        bus.emitIdUserClient(history.id)
      }
    },

    onClickCancel: function () {
      bus.emitResetUserClient()
      this.reset()
    },

    onClickEdit: function () {
      this.editModus = 'edit';
    },

    onClickNew: function () {
      this.reset()
      this.editModus = 'new';
    },

    onClickAddTemplate: function () {
      // Templates an die Message anhängen
      bus.emitAddMessage(this.userClient.calltemplate);
    },
    
    onRemoveMemo: function (memo) {
      const indexOf = this.memos.indexOf(memo);
      if(indexOf != -1){
        this.memos.splice(indexOf, 1);
      }
    },
    
    onSetMemo: function (memo) {
      // Note: kombox is a reference or a clone
      const indexOf = _.findIndex(this.memos, ['id', memo.id]);
      if(indexOf != -1){
        this.$set(this.memos, indexOf, memo);
      }
    },
    
    onAddMemo: function (memo) {
        this.memos.push(memo);
        this.memos = _.sortBy(this.memos, ['typ', 'sorting', 'datetimeBegin']);

    },
    

    onRemoveKombox: function (kombox) {
      const indexOf = this.komboxes.indexOf(kombox);
      if(indexOf != -1){
        this.komboxes.splice(indexOf, 1);
      }
    },
    
    onSetKombox: function (kombox) {
      // Note: kombox is a reference or a clone
      const indexOf = _.findIndex(this.komboxes, ['id', kombox.id]);
      if(indexOf != -1){
        this.$set(this.komboxes, indexOf, kombox);
      }
    },

    onAddKombox: function (kombox) {
        this.komboxes.push(kombox);
    },

    
    onKomboxAddShipping: function (kombox) {
      if(this.shippingIds.indexOf(kombox.id) == -1){
        this.shippingIds.push(kombox.id);
      }
    },

    onKomboxRemoveShipping: function (kombox) {
      this.shippingIds.splice(this.shippingIds.indexOf(kombox.id), 1);
    },

    onHitTypeahead: function (item) {
      bus.emitIdUserClient(item.idUserClient);
    },
    
    
    onIdUserClient: function (idUserClient, event, call) {
      this.reset();

      if(idUserClient > 0){
        this.loadUserClient(idUserClient);
        this.loadMemos(idUserClient, call.idCompanyClient);
        this.loadKomboxes(idUserClient);
      }else{
        // idUserClient == 0 then Call is ended
        this.userClientHistory = [];
      }
      
      this.idCompanyClient = call.idCompanyClient;
    },

    reset: function () {
      this.userClient = {};
      this.memos = [];
      this.komboxes = [];
      this.shippingIds.splice(0 , this.shippingIds.length); // bus refrenz on this.shippingIds
    },
    

    
    loadUserClient: function (idUserClient) {
      this.$http.get(bus.config.path + '/user/client/' + idUserClient).then((response) => {
        this.userClient = response.data;
        //console.log(response.data);
        bus.emitUserClient(this.userClient);
        this.userClientHistory.push(this.userClient);
        
        // send Template to maeessage 
        if(this.userClient.calltemplate){
          this.onClickAddTemplate();
        }
        

      }, (response) => {
      // error callback
      });
    },
    
    saveUserClient: function (userClient) {
      this.$http.post(bus.config.path + '/user/client', 
        userClient).then((response) => {
        this.userClient = response.data;
        bus.emitUserClient(this.userClient);
      }, (response) => {
        // error callback
      });
      this.editModus = false

    },
    
    
    
    

    loadMemos: function (idUserClient, idCompanyClient) {
      this.$http.get(bus.config.path + '/user/memos/' + idUserClient + '/' + idCompanyClient, {params: {typ: '01'}}).then((response) => {
        this.memos = this.memos = _.sortBy(response.data, ['typ', 'sorting', 'datetimeBegin']);

        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },

    loadKomboxes: function (idUserClient) {
      this.$http.get(bus.config.path + '/user/komboxes/' + idUserClient).then((response) => {
        this.komboxes = response.data;
        //console.log(response.data);

      }, (response) => {
      // error callback
      });
    },
    
  }
  
}
</script>



<style scoped>

.panel-group, .panel{
    margin-bottom: 0px;
  }  
  
  .xxxuser-client{
    border: 0px solid lightgrey;
    box-shadow: 0px 0px 3px grey;
    margin-top: 20px;
  }
  
h2 .fa {
    /* padding-right: 6px; */
    color: #337ab7;
}

.cc-kombox-item{
    border-bottom: 1px solid lightgrey;
    padding-top: 5px;
    padding-bottom: 5px;
  
}  

.cc-kombox-item:hover,
.cc-memo-item:hover{
  background-color: #fcf8e3;
}


  .cc-kombox-list,
  .cc-memo-list{
    height: 100%;
    overflow: auto;
    
  }
</style>



// WEBPACK FOOTER //
// UserClient.vue?3099c67f